export default {
	confirmShiftTransferOpenBook: 'confirm_shift_transfer_and_open_book',
	confirmShiftTransfer: 'confirm_shift_transfer',
	closeShift: 'close_shift',
	createCashdeskAct: 'create_cashdesk_act',
	forceShiftClose: 'force_shift_close'
};
